import React from 'react'
import { useState } from 'react';
import SingleServicesImg1 from "../assets/images/services/single-services1.jpg"
import VisionBoxImg from "../assets/images/about/vision-box-img.jpg"
import Services2Img5 from "../assets/images/services/sevices2img5.jpg"
import Services2Img6 from "../assets/images/services/sevices2img6.jpg"
import BtnArrow from '../assets/images/svg/btn-arrow.svg'
import Telephone from '../assets/images/services/telephone.png'
import YouTubeLogo from '../assets/images/services/youtube-logo.png'
import FixHeader from '../component/FixHeader'
import Loader from '../component/Loader'
import LatestBlog from '../component/LatestBlog'
import Footer from '../component/Footer'
import { useNavigate } from 'react-router-dom';

const ServicesDeatils2 = () => {
    const navigate = useNavigate()
    const [isPlaying, setIsPlaying] = useState(false);
    const playVideo = () => {
        setIsPlaying(true);
    };

    return (
        <>
            <Loader />
            <FixHeader />
            {/* <!-- ====================================== Services Section One ===================================== --> */}
            <section className="section-breadcrumb-img" id="about-section-one">
                <div className="container breadcrumb-main">
                    <h1 className="about-h1-text" data-aos="fade-down">Single Services</h1>
                    <ul className="breadcrumb-list about-breadcrumb" data-aos="fade-up">
                        <li className="line-slash" onClick={() => navigate("/")}>Home</li>
                        <li className="line-slash" onClick={() => navigate("/ServicesDetails2")}>Services</li>
                        <li className="active-breadcrumb" onClick={() => navigate("/ServicesDetails2")}>Single Services 2</li>
                    </ul>
                </div>
            </section>
            {/* <!-- ====================================== Services Section Two ===================================== --> */}
            <section className="about-section-two pb-0">
                <div className="container">
                    <div className="row single-services1-row single-services2-row">
                        <div className="col-xxl-4 col-xl-4 col-lg-6 col-md-8">
                            <div className="side-bar-main" data-aos="fade-right">
                                <h2 className="d-none">hidden</h2>
                                <h3 className="ServicesList-Text">Services List</h3>
                                <div>
                                    <div className="servisces-list-arrow-main active">
                                        <img className="btn-arrow" src={BtnArrow} alt="btn-arrow" />
                                        <h4 className="active">Web Copywriter</h4>
                                    </div>
                                    <div className="servisces-list-arrow-main">
                                        <img className="btn-arrow" src={BtnArrow} alt="btn-arrow" />
                                        <h4 className="active">Digital Copywriting</h4>
                                    </div>
                                    <div className="servisces-list-arrow-main">
                                        <img className="btn-arrow" src={BtnArrow} alt="btn-arrow" />
                                        <h4 className="active">Email Copywriting</h4>
                                    </div>
                                    <div className="servisces-list-arrow-main">
                                        <img className="btn-arrow" src={BtnArrow} alt="btn-arrow" />
                                        <h4 className="active">Blog Content Writer</h4>
                                    </div>
                                    <div className="servisces-list-arrow-main">
                                        <img className="btn-arrow" src={BtnArrow} alt="btn-arrow" />
                                        <h4 className="active">Press Release Writer</h4>
                                    </div>
                                    <div className="servisces-list-arrow-main">
                                        <img className="btn-arrow" src={BtnArrow} alt="btn-arrow" />
                                        <h4 className="active">Video Script Writer</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="contact-side-bar aos-init aos-animate" data-aos="fade-up">
                                <img className="telephone-img" src={Telephone} alt="call" />
                                <h4>Get In Touch</h4>
                                <p className="resolving">Ready to assist you in resolving any legal issues you may have.</p>
                                <div className="hire-me-btn-main">
                                    <div onClick={() => navigate("/Contact")} className="button button1" data-text="Contact">
                                        <span>Contact</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-8 col-xl-8 col-lg-12 col-md-12">
                            <div className="video-container2 single-services-main-img">
                                {!isPlaying && (
                                    <>
                                        <img className="cover" src={SingleServicesImg1} alt="Video Cover" />
                                        <img className="play-button" src={YouTubeLogo} alt="Play Button" onClick={playVideo} />
                                    </>
                                )}
                                <div className="video-wrapper">
                                    {isPlaying && (
                                        <iframe
                                            id="youtube-video"
                                            src="https://www.youtube.com/embed/TqFU1vle48k?si=wBcN42ZkO_ble_yy-&autoplay=1"
                                            frameBorder="0"
                                            allow="autoplay; encrypted-media"
                                            allowFullScreen
                                            title="YouTube Video"
                                        >
                                        </iframe>
                                    )}
                                </div>
                            </div>
                            <h2 className="Singleservices-text-main ">Web Copywriter</h2>
                            <p className="commodo">Commodo semper bibendum adipiscing orci bibendum eu lectus sed. Commodo
                                cursus vitae augue luctus nibh. Congue sit quisque volutpat libero tempor a id cursus purus.
                                Pellentesque pellentesque scelerisque curabitur porta dolor. Amet vulputate vitae eget sit
                                rhoncus imperdiet. Odio justo nullam scelerisque quis bibendum. Cras ipsum vel diam praesent
                                tortor at elit sit. A risus molestie bibendum donec blandit adipiscing volutpat sollicitudin
                                aliquam. Nec arcu cras ultrices velit sed ligula. Iaculis elit vulputate sollicitudin
                                quisque ut faucibus.</p>
                            <p className="commodo pt-2">Facilisis nec malesuada enim viverra cras. Auctor dignissim tellus
                                vestibulum vitae hac amet. Suspendisse sit feugiat in pulvinar bibendum arcu nunc id. Duis
                                hac nisl dui facilisi placerat at mauris elit scelerisque. Turpis ornare auctor amet
                                vestibulum in magna aliquet ultricies netus. Adipiscing lobortis a interdum morbi etiam non.
                                Elit sed magna risus tempor non quis. Nec pulvinar scelerisque in faucibus.</p>
                            <div className="check-list-main-grid">
                                <div className="img-animation-style4 reveal">
                                    <img className="vision-box-img2" src={VisionBoxImg} alt="vision-box-img" />
                                </div>
                                <div>
                                    <h3 className="check-list" data-aos="fade-up">Content Write Checklist</h3>
                                    <ul className="why-choose-list p-0" data-aos="fade-up">
                                        <li>We Create High Quality Content.</li>
                                        <li>We Focus on Well Organize Content.</li>
                                        <li>We Deliver On Time.</li>
                                        <li>We have best writer resources.</li>
                                        <li className="mb-0">Content Campaigns.</li>
                                    </ul>
                                </div>
                            </div>
                            <p className="commodo">Tortor quam congue habitasse egestas facilisi quis feugiat. Leo semper
                                quisque ipsum felis feugiat dolor erat. Pellentesque sit a pellentesque sed amet ac ipsum
                                ac. Leo eget at ultricies varius. Leo facilisis nec malesuada posuere nulla aliquet sed
                                purus dolor. Sit parturient varius egestas et ut orci viverra venenatis. Arcu enim ut
                                malesuada orci sit mattis a lectus. Cursus penatibus fusce et vel nullam. Auctor non laoreet
                                nibh tellus consequat risus nibh volutpat. Neque volutpat amet varius at eget lectus.</p>
                            <div className="single-services-imgs-group img-animation-style1 reveal active">
                                <img src={Services2Img5} alt="sevices2img5" />
                                <img src={Services2Img6} alt="sevices2img6" />
                            </div>
                            <p className="commodo">Facilisis nec malesuada enim viverra cras. Auctor dignissim tellus vestibulum
                                vitae hac amet. Suspendisse sit feugiat in pulvinar bibendum arcu nunc id. Duis hac nisl dui
                                facilisi placerat at mauris elit scelerisque. Turpis ornare auctor amet vestibulum in magna
                                aliquet ultricies netus. Adipiscing lobortis a interdum morbi etiam non. Elit sed magna
                                risus tempor non quis. Nec pulvinar scelerisque in faucibus.</p>
                            <p className="commodo pt-2">Dis morbi cursus aliquam rutrum tortor amet. Mauris consequat libero
                                praesent pellentesque nibh sed eget urna. Leo at feugiat vel dictum eget quam et commodo
                                nullam. Nec arcu egestas adipiscing mollis dapibus justo non.</p>
                        </div>
                    </div>
                </div>
            </section>
            <LatestBlog />
            <Footer />
        </>
    )
}

export default ServicesDeatils2